import request from "@/utils/request.js";
//获取学习资料列表
export const getLearningMaterialList = (data) => {
	return request({
		method: "post",
		url: "api/LearningMaterials/GetLearningMaterialList",
		data
	});
};

//获取专家列表
export const getIndustryExpertList = (data) => {
	return request({
		method: "post",
		url: "api/IndustryExpert/GetIndustryExpertList",
		data
	});
};

//删除学习资料
export const DeleteLearnMaterials = (data) => {
	return request({
		method: "post",
		url: "api/LearningMaterials/DeleteLearnMaterials",
		data
	});
};
//删除专家
export const DelIndustryExpert = (data) => {
	return request({
		method: "post",
		url: "api/IndustryExpert/DeleteLearnMaterials",
		data
	});
};
// 获取报名用户列表
export const GetUserInfoList = (data) => {
	return request({
		method: "post",
		url: "api/MeetingSignature/GetUserInfoList",
		data
	});
};
// 设置用户报名状态
export const SetUserStatus = (data) => {
	return request({
		method: "post",
		url: "api/MeetingSignature/SetUserStatus",
		data
	});
};
//获取申请列表
export const GetApplyExprienceList = (data) => {
	return request({
		method: "post",
		url: "api/MeetingSignature/GetApplyExprienceList",
		data
	});
};
// 设置申请状态
export const SetApplyExprienceStatus = (data) => {
	return request({
		method: "post",
		url: "api/MeetingSignature/SetApplyExprienceStatus",
		data
	});
};